/* ─── ALL SITE DATA ─── */

export const NAV_ITEMS = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "services", label: "Services", isDropdown: true },
  { id: "portfolio", label: "Case Studies" },
  { id: "contact", label: "Contact", isCta: true },
];

export const SERVICE_DROPDOWN = [
  { id: "ai", label: "AI & Intelligent Automation", icon: "🤖" },
  { id: "cloud", label: "Cloud Architecture & DevOps", icon: "☁️" },
  { id: "design", label: "Digital Product Design", icon: "🎨" },
  { id: "software", label: "Enterprise Software Engineering", icon: "⚙️" },
  { id: "it", label: "Data Strategy & Analytics", icon: "📊" },
  { id: "digital", label: "Cybersecurity & Risk Mitigation", icon: "🛡️" },
  { id: "transformation", label: "Digital Business Transformation", icon: "🔄" },
];

export const LANDING = {
  hero: {
    subtitle: "We bridge the gap between complex technology and seamless user experiences through custom software, AI-driven data and digital transformation",
    bgImage: "/assets/homestatic.png",
    bgVideo: "/assets/hero-video.mp4",
    marquee: "DIGITAL TRANSFORMATION  +  SOFTWARE DEVELOPMENT  +  AI & DATA  +  CLOUD SERVICES  +  CYBERSECURITY  +  ",
  },
  about: {
    label: "About us",
    heading: ["Empowering the", "Global Digital", "Frontier"],
    description: "At Rising Sun Globalized Firm, we don\u2019t just build software\u2014we engineer the future. With over a decade of expertise, we serve as the technical backbone for ambitious brands worldwide. From the complexities of AI-driven intelligence to the rigors of enterprise cybersecurity, our mission is to provide the stability and innovation required to lead in a hyper-connected world. We bridge the gap between visionary ideas and global-scale execution.",
  },
  whatWeDo: {
    label: "Services",
    title: "Why Global Leaders Choose Rising Sun.",
    image: "/assets/services-banner.png",
  },
  serviceFeature: {
    title: ["Strategic Solutions for a", "Digital-First World."],
    description: "We transform technical complexity into your competitive advantage. Rising Sun provides the end-to-end expertise required to build, secure, and scale your global operations.",
    features: [
      "Global-Ready Scalability: Our solutions are designed to handle millions of users across multiple time zones without a glitch.",
      "Built for the AI-First Era: We bypass legacy limitations to architect intelligence-native ecosystems for the modern global enterprisel.",
      "Zero-Trust Security: We integrate security into the very first line of code, not as an afterthought.",
      "Strategic Solutions for a Digital-First World.",
      "We transform technical complexity into your competitive advantage. Rising Sun provides the end-to-end expertise required to build, secure, and scale your global operations.",
      "We empower global enterprises to outpace the competition by integrating the world's most advanced App Development, Digital Transforamaion, Cloud Architectures and Artificial Intelligence. At Rising Sun, we don't just solve IT problems; we build intelligent, self-scaling ecosystems that turn your data into your greatest asset."
    ],
    image: "/assets/services-banner.png",
  },
  recentProjects: {
    label: "Portfolio",
    title: "Recent Projects",
    projects: [
      { title: "Street-Smart Digital Ecosystem", desc: "Transforming Urban Spaces into Intelligent Advertising Networks", tag: "#webdesign", image: "/assets/project-banner.png" },
      { title: "Street-Smart Digital Ecosystem", desc: "Transforming Urban Spaces into Intelligent Advertising Networks", tag: "#webdesign", image: "/assets/project-banner.png" },
    ],
  },
  whyChoose: {
    label: "Solutions",
    title: "Why choose Rising sun",
    rotatingItems: [
      "Global Expertise",
      "Intelligent Automation",
      "Scalable Enterprise Solutions",
    ],
    description: ["Our borderless operational reach ensures that Rising Sun clients benefit from a follow-the-sun development model and localized support in every corner of the globe.", "We transcend basic automation by engineering self-evolving cognitive ecosystems. By integrating the latest in AI and agentic workflows, we eliminate operational friction and unlock unprecedented levels of enterprise productivity.", "We build for tomorrow's scale. Our architectures are engineered for extreme resilience and infinite scalability, ensuring your digital infrastructure remains performant as you capture new market opportunities across continents."],
  },
  techEcosystem: {
    label: "Frameworks",
    title: "Our Technology Ecosystem",
    description: "We leverage a curated suite of industry-leading technologies, engineered for absolute reliability and infinite global scalability.",
    tools: [
      { name: "Photoshop", image: "/assets/tech/Adobe Photoshop.png" },
      { name: "AI", image: "/assets/tech/ai.png" },
      { name: "XD", image: "/assets/tech/Adobe XD.png" },
      { name: "React", image: "/assets/tech/React.png" },
      { name: "JavaScript", image: "/assets/tech/JavaScript.png" },
      { name: "Bootstrap", image: "/assets/tech/Bootstrap.png" },
      { name: "CSS", image: "/assets/tech/CSS3.png" },
      { name: "HTML", image: "/assets/tech/HTML5.png" },
      { name: "Node.js", image: "/assets/tech/Node.js.png" },
      { name: "MongoDB", image: "/assets/tech/MongoDB.png" },
      { name: "Python", image: "/assets/tech/Python.png" },
      { name: "AWS", image: "/assets/tech/AWS.png" },
      { name: "Figma", image: "/assets/tech/Figma.png" },
      { name: "GitHub", image: "/assets/tech/GitHub.png" },
      { name: "R", image: "/assets/tech/R.png" },
      { name: "Angular", image: "/assets/tech/Angular.png" },
      { name: "Java", image: "/assets/tech/Java.png" },
      { name: "Laravel", image: "/assets/tech/Laravel.png" },
      { name: ".NET", image: "/assets/tech/NET.png" },
      { name: "PHP", image: "/assets/tech/PHP.png" },
      { name: "Spring", image: "/assets/tech/Spring.png" },
      { name: "WordPress", image: "/assets/tech/WordPress.png" },
    ],
  },
  team: {
    label: "Our Team",
    title: "A Team of Rising Sun",
    members: [
      { name: "Daniel Reyes", role: "CEO", image: "/assets/team/DanielReyes.png", desc: "Leads the global vision and strategic direction of Rising Sun Globalized Firm. The CEO focuses on building international partnerships, expanding market presence, and aligning innovation with business growth. With a strong emphasis on global intelligence and digital transformation, the CEO ensures every solution delivers measurable value." },
      { name: "Michael Tanaka", role: "CTO", image: "/assets/team/MichaelTanaka.png", desc: "Drives the technology strategy and oversees all engineering operations. The CTO architects scalable solutions, evaluates emerging technologies, and ensures technical excellence across every project delivered." },
      { name: "Jonathan Clarke", role: "COO", image: "/assets/team/JonathanClarke.png", desc: "Manages day-to-day operations and ensures seamless delivery across all business units. The COO optimizes processes, manages resources, and maintains operational excellence at scale." },
      { name: "Sophia Martinez", role: "UX Designer", image: "/assets/team/SophiaMartinez.png", desc: "Crafts intuitive user experiences and leads the design vision. Sophia ensures every interface is accessible, beautiful, and aligned with user needs and business objectives." },
    ],
  },
  customSolutions: {
    heading: ["Custom Solutions", "For Your Business"],
    items: [
      { num: "01", label: "Web Development", active: true },
      { num: "02", label: "WordPress Customization" },
      { num: "03", label: "Web UX/UI" },
      { num: "04", label: "Website Migration" },
      { num: "05", label: "Shopify Customization" },
    ],
    preview: {
      image: "/assets/webDev.png",
      title: "Web Development",
      desc: "Fast, scalable, custom websites built to perform.",
    },
  },
  serviceBanner: {
    image: "/assets/digitalTran.png",
    title: "Digital Transformation Consulting",
    desc: "We help global enterprises define their new path of transformation.",
  },
};

export const ABOUT = {
  hero: {
    label: "The Standard for Global Intelligence",
    heading: ["Know about our", "digital agency"],
    description:
      "Rising Sun Globalized Firm was founded to challenge the status quo of traditional IT consulting. In a world where technology moves faster than corporate bureaucracy, we provide the agility, precision, and high-level engineering required for true digital evolution. From our strategic hubs in Chennai and Hong Kong, we deliver a localized perspective with a global impact, ensuring your infrastructure is as ambitious as your vision.",
  },
  vision: {
    icon: "\ud83c\udf10",
    title: "Our Vision",
    text: "Rising Sun Globalized Firm is committed to architecting the next era of enterprise intelligence. We exist to simplify technical complexity and catalyze digital evolution for ambitious organizations on a global scale.",
  },
  visionCard: {
    icon: "/assets/aboutus/world.png",
    title: "Global Operational Excellence",
    text: "To become the definitive partner for cross-border digital transformation, bridging continents with resilient, high-availability infrastructure and autonomous AI ecosystems.",
  },
  approach: {
    title: "The Rising Sun Methodology",
    subtitle: "Our proven methodology integrates high-level architectural foresight with agile execution to ensure your enterprise remains at the vanguard of digital innovation.",
    steps: [
      { num: "01", title: "Root Cause Analysis (RCA)", desc: "We conduct comprehensive technical audits to align your legacy infrastructure with global market demands. We translate your business vision into a scalable, high-performance architectural roadmap.", icon: "/assets/aboutus/target.png" },
      { num: "02", title: "Strategic Architecture", desc: "We engineer bespoke, cloud-native frameworks designed for high-availability and extreme scale. Our architectures prioritize modularity and security, ensuring your digital infrastructure remains resilient as your enterprise evolves.", icon: "/assets/aboutus/light.png" },
      { num: "03", title: "High-Velocity Execution", desc: "Leveraging our dual-hub operations in Chennai and Hong Kong, we employ a \u201cFollow-the-Sun\u201d model (Agility). This ensures continuous momentum, rapid deployment, and a significantly reduced time-to-market.", icon: "/assets/aboutus/arrow.png" },
      { num: "04", title: "Lifecycle Optimization", desc: "We provide 24/7 technical oversight and AI-driven telemetry to ensure peak system health. We don\u2019t just maintain your assets; we evolve them to maintain your competitive edge.", icon: "/assets/aboutus/rocket.png" },
    ],
  },
  team: {
    label: "OUR TEAM",
    title: "The Strategic Leadership",
    subtitle: "A global collective of strategists, engineers, and visionaries dedicated to engineering the future of enterprise intelligence.",
    members: [
      { name: "Daniel Reyes", role: "CEO", image: "/assets/team/DanielReyes.png" },
      { name: "Michael Tanaka", role: "CTO", image: "/assets/team/MichaelTanaka.png" },
      { name: "Jonathan Clarke", role: "COO", image: "/assets/team/JonathanClarke.png" },
      { name: "Sophia Martinez", role: "UX Designer", image: "/assets/team/SophiaMartinez.png" },
    ],
  },
};

export const SOFTWARE = {
  hero: {
    category: "Enterprise Software Engineering",
    title: "High-Performance Engineering for Complex Needs",
    description:
      "Design Systems & Prototyping: Developing scalable, modular design libraries that ensure visual consistency across all enterprise platforms and devices.",
    image: "/assets/softwareDev.png",
  },
  pillars: [
    { icon: "\u2699\ufe0f", title: "Custom SaaS Development", desc: "Building scalable platforms with modern stacks (Java, Node, Python, Go)." },
    { icon: "\ud83d\udd04", title: "Legacy Refactoring", desc: "Modernizing old codebases into fast, cloud-native apps." },
    { icon: "\ud83d\udd17", title: "API Ecosystems", desc: "Engineering secure bridges between your internal systems." },
    { icon: "\ud83d\udcf1", title: "Web & Next-Gen Mobile Development", desc: "High-performance web applications & Native and Cross-Platform applications (iOS & Android)." },
  ],
};

export const AI = {
  hero: {
    category: "AI & Intelligent Automation",
    title: "Architecting Tomorrow's Intelligence.",
    description:
      "We deploy cutting-edge AI solutions that transform how enterprises operate, decide, and scale.",
    image: "/assets/AIDev.png",
  },
  capabilities: [
    { icon: "\ud83e\udde0", title: "Generative AI Integration", desc: "Custom LLM deployments and secure internal AI agents." },
    { icon: "\ud83e\udd16", title: "Agentic Workflows", desc: "Automating complex business logic with autonomous AI." },
    { icon: "\ud83d\udcca", title: "Machine Learning Models", desc: "Predictive analytics for market trend forecasting." },
    { icon: "\ud83d\udd17", title: "MCP Task Integration", desc: "Expanding AI & Intelligent Automation to include MCP Task integration for enterprise workflows." },
  ],
};

export const DIGITAL = {
  hero: {
    category: "Cybersecurity & Risk Mitigation",
    title: "Security-by-Design for Digital Assets",
    description:
      "We embed security into every layer of your digital infrastructure, ensuring your enterprise stays protected against evolving threats.",
    image: "/assets/digitalTran.png",
  },
  pillars: [
    { icon: "\ud83d\udee1\ufe0f", title: "Threat Intelligence", desc: "Proactive monitoring and vulnerability assessments." },
    { icon: "\ud83d\udd10", title: "Zero-Trust Architecture", desc: "Implementing rigorous identity and access management." },
    { icon: "\ud83d\udccb", title: "Compliance Governance", desc: "Ensuring your tech meets global standards (GDPR, ISO)." },
  ],
};

export const CLOUD = {
  hero: {
    category: "Cloud Architecture & DevOps",
    title: "Resilient Infrastructure for Global Scaling",
    description:
      "We architect and manage robust cloud environments that scale with your global ambition.",
    image: "/assets/cloudDev.png",
  },
  platforms: [
    { icon: "\u2601\ufe0f", name: "Cloud Migration", desc: "Seamless transition to AWS, Azure, or Google Cloud." },
    { icon: "\ud83d\udd37", name: "Hybrid & Multi-Cloud", desc: "Designing for 99.99% uptime and zero-latency." },
    { icon: "\u2699\ufe0f", name: "Infrastructure as Code (IaC)", desc: "Automating deployment for high-velocity growth." },
  ],
};

export const IT = {
  hero: {
    category: "Data Strategy & Analytics",
    title: "Engineering Data Intelligence for the Modern Enterprise",
    description:
      "We turn your raw data into your most powerful strategic asset through governance, predictive modeling, and real-time intelligence.",
    image: "/assets/ITdev.png",
  },
  offerings: [
    { icon: "\ud83d\uddc4\ufe0f", title: "Data Governance & Architecture", desc: "We design secure, scalable data lakes and warehouses that ensure \u201cSingle Source of Truth\u201d integrity across your entire global operation." },
    { icon: "\ud83d\udcca", title: "Predictive Analytics & Modeling", desc: "Utilizing advanced statistical algorithms to forecast market shifts, consumer behavior, and operational risks before they manifest." },
    { icon: "\ud83d\udcc8", title: "Automated Business Intelligence (BI)", desc: "Implementation of real-time, high-fidelity dashboards that translate complex datasets into actionable executive insights." },
  ],
};

export const DESIGN = {
  hero: {
    category: "Digital Product Design",
    title: "Engineering Intuition into Enterprise Intelligence.",
    description:
      "We craft digital experiences that are as intelligent as they are beautiful, ensuring every interaction drives business value.",
    image: "/assets/UXdev.png",
  },
  services: [
    { icon: "\ud83c\udfa8", title: "User Experience (UX) Architecture", desc: "Conducting behavioral research and wireframing to map seamless, friction-free user journeys." },
    { icon: "\u270f\ufe0f", title: "High-Fidelity UI Design", desc: "Crafting sophisticated, modern interfaces that reflect your brand's global authority and technical precision." },
    { icon: "\ud83d\udcf1", title: "Design Systems & Prototyping", desc: "Developing scalable, modular design libraries that ensure visual consistency across all enterprise platforms and devices." },
  ],
};

export const TRANSFORMATION = {
  hero: {
    category: "Digital Transformation Strategy",
    title: "Navigating the Evolution of Global Commerce",
    description:
      "We guide enterprises through the complexities of digital evolution with strategic clarity and technical precision.",
    image: "/assets/digitalTran.png",
  },
  pillars: [
    { icon: "\ud83d\udd04", title: "Legacy Modernization Roadmap", desc: "A calculated approach to refactoring outdated systems into high-performance, cloud-native environments without disrupting core operations." },
    { icon: "\u2699\ufe0f", title: "Operational Process Automation", desc: "Identifying workflows that drain resources and implementing intelligent automation to maximize human capital." },
    { icon: "\ud83c\udf10", title: "Digital Ecosystem Orchestration", desc: "Integrating your CRM, ERP, and proprietary tools into a seamless, interoperable ecosystem that operates flawlessly across borders." },
  ],
};

export const PORTFOLIO = {
  hero: {
    title: "Smart City & Urban AdTech",
    image: "/assets/portfolioBanner.png",
    summary:
      "The Challenge: Outdated urban infrastructure and static, non-engaging public communication. Our Solution: We integrate IoT sensors, Edge Computing, and Programmatic Ad-Tech to turn city streets into intelligent data hubs. The Result: Real-time, reactive advertising networks like Street-Smart that increase engagement and provide sustainable revenue for urban developers.",
  },
  projects: [
    { title: "Street-Smart Digital Ecosystem", desc: "Transforming Urban Spaces into Intelligent Advertising Networks", tag: "#webdesign", image: "/assets/portfolioBanner.png" },
    { title: "FinTech Payment Gateway", desc: "Secure, real-time payment processing for global transactions.", tag: "#fintech", image: "/assets/portfolioBanner.png" },
    { title: "HealthCare AI Platform", desc: "AI-driven diagnostics and patient management system.", tag: "#healthtech", image: "/assets/portfolioBanner.png" },
    { title: "E-Commerce Marketplace", desc: "Scalable multi-vendor marketplace with real-time analytics.", tag: "#ecommerce", image: "/assets/portfolioBanner.png" },
  ],
};

export const TESTIMONIALS = [
  { name: "Daniel Reyes", role: "Useful", text: "They completely transformed the user flow. Bounce rates dropped by half after the redesign." },
  { name: "Daniel Reyes", role: "Useful", text: "They completely transformed the user flow. Bounce rates dropped by half after the redesign." },
  { name: "Daniel Reyes", role: "Useful", text: "They completely transformed the user flow. Bounce rates dropped by half after the redesign." },
  { name: "Daniel Reyes", role: "Useful", text: "They completely transformed the user flow. Bounce rates dropped by half after the redesign." },
  { name: "Daniel Reyes", role: "Useful", text: "They completely transformed the user flow. Bounce rates dropped by half after the redesign." },
];

export const CONTACT = {
  label: "",
  heading: ["Enterprise Solutions for", "a Connected World"],
  subheading: "Custom-engineered technical roadmaps designed for performance and interoperability.",
  projectTypes: [
    "Web Development", "Mobile App", "UI/UX Design", "Cloud Infrastructure",
    "AI & Data", "Cybersecurity", "Digital Transformation", "Other",
  ],
  solutions: [
    {
      title: "Artificial Intelligence & Data Strategy",
      tagline: "Transforming raw data into your company\u2019s most valuable asset.",
      items: [
        { label: "Automation Solutions", desc: "Streamline operations with custom LLMs and Generative AI." },
        { label: "Predictive Insights", desc: "Anticipate market shifts using advanced machine learning models." },
        { label: "Data Governance", desc: "Secure, global-scale data warehousing and management." },
      ],
    },
    {
      title: "Cloud Modernization & Scaling",
      tagline: "Zero-downtime infrastructure for global availability.",
      items: [
        { label: "Hybrid & Multi-Cloud", desc: "Architecting resilient systems across AWS, Azure, and Google Cloud." },
        { label: "Cloud-Native Development", desc: "Building apps that scale automatically as you grow." },
        { label: "Cost Optimization", desc: "Reducing your monthly cloud spend while increasing performance." },
      ],
    },
    {
      title: "Digital Transformation & Strategy",
      tagline: "Evolving your business for the digital age.",
      items: [
        { label: "Legacy Modernization", desc: "Upgrading your old systems to modern, fast, and secure platforms." },
        { label: "UX/UI Innovation", desc: "Designing intuitive interfaces that increase user retention and satisfaction." },
      ],
    },
    {
      title: "The MCP Advantage (Model Context Protocol) \u00b7 AI Interoperability",
      tagline: "",
      items: [
        { label: "Seamless AI Interoperability", desc: "We implement MCP frameworks to securely integrate AI agents with disparate data sources, ensuring unified intelligence across your organization." },
        { label: "Context-Aware Architectures", desc: "Utilizing MCP to provide AI models with secure, real-time access to local and remote environments, significantly reducing latency and hallucinations." },
        { label: "Bespoke Server Development", desc: "Engineering custom MCP servers to bridge legacy infrastructure with modern AI interfaces, future-proofing your technical stack." },
      ],
    },
  ],
  supportNote: "With strategic hubs in Chennai and Hong Kong, we provide 24/7 technical oversight and localized expertise for clients across Asia, Europe, and the Americas.",
  formTitle: "Global Inquiries",
};

export const FOOTER_DATA = {
  email: "ramesh@risingsunglobal.tech",
  phones: ["+852 6220 5431", "+91 99404 83441"],
  cta: "Scale Your Vision Globally",
  hongKong: {
    title: "Hong Kong",
    name: "Strategic Operations Centre",
  },
  chennai: {
    title: "Chennai",
    name: "Rising Sun Globalized Firm",
    address: ["No. 90, Opposite Sameera New Vision Township,", "Vengambakkam, Tamil Nadu, India - 600048."],
    location: "https://maps.app.goo.gl/GXNQVjiwjJcYHTKS8"
  },
  links: ["About", "Services", "Case Studies", "Technology Solutions", "Contact", "Terms & Conditions"],
  legal: ["Privacy Policy", "Cookie Policy", "Legal"],
  socials: [
    { icon: "in", label: "LinkedIn", url: "https://www.linkedin.com/in/rising-sun-globalized-firm/" },
    { icon: "📷", label: "Instagram", url: "https://www.instagram.com/risingsunglobalfirm/" },
    { icon: "✉", label: "Email", url: "https://mail.google.com/mail/?view=cm&to=ramesh@risingsunglobal.tech" },
  ],
};
